module.exports = __webpack_public_path__ + "img/水上智能航空站.b49fa65b.png";